import { isBrowserEnv } from "@visactor/vrender-core/env";

export const browser = isBrowserEnv();